import React from 'react';
import { Col, Container, Row, Image } from 'react-bootstrap';
import HeadShot from '../images/headshot2.jpg';


const AboutMe = () => {
    return (
        <div className="section">
            <Container className="experience">
                <Row>
                    <Col md={12}>
                        <h1>About Me</h1>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col md={8} sm={12}>
                        <p className="intro">
                            Hello, I’m Greg from Perth, Scotland 🏴󠁧󠁢󠁳󠁣󠁴󠁿 I'm a full-stack software engineer with
                            over 7 years of experience delivering high-impact solutions across both start-ups
                            and large tech companies. I've been programming for over a decade and have a real
                            passion for learning new things! I'm not afraid to try anything new or dive into
                            unfamiliar tech stacks.<br /><br />

                            I'm currently working for PetsApp as a full-stack software engineer. I'm responsible for
                            leading the architectural and feature development for the veterinary communication platform.
                            I'm also responsible for the development of the React Native mobile app across Android and iOS.
                            I'm also responsible for the development of the backend services for the platform. <br /><br />

                            Previously at Amazon, I worked across both Prime Video and AWS. I started as a backend engineer
                            doing everything AWS and Java, but found myself loving projects with real customer impact,
                            which led me to more full-stack work. Highlights include leading the DevOps Guru integration
                            with Amazon RDS (resulting in a 250% increase in adoption), identifying infrastructure
                            optimisations that saved approximately $1M annually, and building a predictive alarming
                            system to monitor all 8,000+ Prime Video devices.<br /><br />

                            Throughout my career, I've worked closely with senior product managers, senior UX designers,
                            principal engineers and managers. My background spans a range of organisational sizes, enabling
                            me to develop large-scale infrastructure architecture while maintaining a high quality bar for
                            business-critical services.<br /><br />

                            Before joining PetsApp, I took time off to travel around Europe with my wife in our van, Judi! 🚐<br /><br />
                        </p>
                    </Col>
                    <Col md={4} sm={12}>
                        <Image src={HeadShot} fluid roundedCircle />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default AboutMe;
